<template>
  <header-bar>
    <div id="home">

      <div id="home-banner">
        <img class="home-banner-icon" src="https://order-api.yakult-gz.com.cn/upload/images/home.png" alt="">
        <!--                <div v-show="isNotice" class="description" style="position: absolute" v-html="notice"></div>-->
        <!--                <div v-show="isNotice" class="description" v-html="notice"></div>-->
      </div>

      <div id="place-order-type" class="tab-container">
        <div class="tab-wrapper">
          <div class="tab" :class="{ 'tab-active': isPackage, 'tab-inactive': !isPackage }" @click="selectOrder(true)">
            <div class="tab-text">经典单品</div>
          </div>
          <div class="tab" :class="{ 'tab-active': !isPackage, 'tab-inactive': isPackage }" @click="selectOrder(false)">
            <div class="tab-content">
              <div class="tab-text">预售商品</div>
              <div class="new-tag">NEW!</div>
            </div>
          </div>
        </div>
      </div>
      <div id="home-body">
        <!--  单品-->
        <div v-if="isPackage" class="good-list">
<!--             <div class="tip-notice">-->
<!--              <div class="tip-notice-icon">📢</div>-->
<!--              <div class="tip-notice-content">低糖10支属于预售商品，6月1号 - 4 号期间不能与其他商品同时下单，请分开下单。</div>-->
<!--          </div>-->
          <!--  通过循环显示商品列表  -->
          <div class="home-body-yakult" v-for="item in produceData" :key="item.id">

            <img class="home-body-bg-yakult" :src="item.imageUrl" alt=""/>
            <div class="description">
              <div class="new-product-tag" v-if="item.isNew === '1'">新品</div>
<!--              <div class="presale-tag" v-if="item.isNew === '1'">预售</div>-->
              <div v-if="item.id === 1" class="description-title">{{ GOODS.YAKULT }}{{
                  GOODS.YAKULT_ABBREVIATION
                }}
              </div>
              <div v-if="item.id === 2" class="description-title-low">{{ GOODS.YAKULT }}{{
                  GOODS.YAKULT_DT_ABBREVIATION
                }}
              </div>
              <div v-if="item.id === 3" class="description-title-500low">
                {{ GOODS.YAKULT }}{{ GOODS.YAKULT_SUGAR_FREE_ABBREVIATION }}
              </div>
              <div v-if="item.id === 4" class="description-title-peach">
                {{ GOODS.YAKULT }}{{ GOODS.YAKULT_PEACH_ABBREVIATION }}
              </div>
              <div v-if="item.id === 5" class="description-title">{{ GOODS.YAKULT }}{{
                  GOODS.YAKULT_ABBREVIATION
                }}10支
              </div>
              <div v-if="item.id === 6" class="description-title-grape">
                {{ GOODS.YAKULT }}{{ GOODS.YAKULT_GRAPE_ABBREVIATION }}
              </div>
              <div v-if="item.id === 8" class="description-title-mango">
                {{ GOODS.YAKULT }}{{ GOODS.YAKULT_MANGO_ABBREVIATION }}
              </div>
              <div v-if="item.id === 11" class="description-title-low">
                {{ GOODS.YAKULT }}{{ GOODS.YAKULT_TEN_DT_ABBREVIATION }}
              </div>

              <div class="description-content" style="margin-top: 0.8vh">规格: {{ item.spec }}</div>
              <div class="description-content">保质期: 30天</div>
              <div class="description-content" @click="showGoodInfo(item)">(点击查看产品详情)
              </div>
              <div class="con-down">
                <div class="price-num">
                  <span style="font-weight: 500;">RMB: </span>
                  <span style="color: #ea2d53; font-weight:500 ">{{ item.price }}</span>
                </div>
                <div class="price-btn" @click="placeOrder(0)">
                  去购买
                </div>
              </div>
            </div>
            <hr class="hr1" v-if="item.lineShow"/>
          </div>


          <!--          <div class="purchase" @click="placeOrder()">-->
          <!--            <span style="color: white;font-size: 1.5rem;font-weight: bold">立即购买</span>-->
          <!--          </div>-->

        </div>

        <!--  预售订单-->
        <div v-if="!isPackage" class="good-list">
          <!-- 提示信息 -->
          <div class="tip-notice">
              <div class="tip-notice-icon">📢</div>
              <div class="tip-notice-content">预售商品下单后，需要3个工作日左右才能安排配送，因此无法与普通单品同时下单</div>
          </div>
          <!--  通过循环显示商品列表  -->
          <div class="home-body-yakult" v-for="item in preProduceData" :key="item.id">
            <img class="home-body-bg-yakult" :src="item.imageUrl" alt=""/>
            <div class="description">
              <div class="new-product-tag" v-if="item.isNew === '1'">新品</div>
              <div v-if="item.id === 9" class="description-title">{{ GOODS.YAKULT }}{{
                  GOODS.YAKULT_TWENTY_ABBREVIATION
                }}
              </div>
              <div v-if="item.id === 10" class="description-title-low">{{ GOODS.YAKULT }}{{
                  GOODS.YAKULT_TWENTY_DT_ABBREVIATION
                }}
              </div>
              <div v-if="item.id === 7" class="description-title-grape">
                {{ GOODS.YAKULT }}{{ GOODS.YAKULT_TWENTY_GRAPE_ABBREVIATION }}
              </div>

              <div class="description-content" style="margin-top: 0.8vh">规格: {{ item.spec }}</div>
              <div class="description-content">保质期: 30天</div>
              <div class="description-content" @click="showGoodInfo(item)">(点击查看产品详情)
              </div>

              <div class="con-down">
                <div class="price-num">
                  <span style="font-weight: 500;">RMB: </span>
                  <span style="color: #ea2d53; font-weight:500;">{{ item.price }}</span>
                </div>
                <div class="price-btn" @click="placeOrder(1)">
                  去购买
                </div>
              </div>
            </div>
            <hr class="hr1" v-if="item.lineShow"/>
          </div>
        </div>

        <!-- <PackageCard :packageData="packageData" @placePackageOrder="placePackageOrder"/> -->


      </div>

      <div class="computer">
        广州益力多乳品有限公司
        <div>营业执照号:<span class="blis" @click="dialogBLIS(1)">914401167256483571</span></div>
        <div>国家食品药品监督管理局:<span class="blis" @click="dialogBLIS(2)">国食健字G20041493</span></div>
        <div>食品经营许可证:<span class="blis" @click="dialogBLIS(3)">JY14001120048469(1-1)</span></div>
        <div>食品生产许可证:<span class="blis" @click="dialogBLIS(4)">SC12744011601088</span></div>
      </div>

      <div class="computer-footer"></div>

      <good-info-dialog v-show="isShowGoodInfo" :title="title" :weight="weight" :description="description"
                        @close="close"></good-info-dialog>
      <!--公告-->
      <rule-info-dialog v-if="isNotice" :description="notice" @close="closeRule"></rule-info-dialog>
      <good-info-dialog v-show="isShowGoodInfo" :title="title" :weight="weight" :description="description"
                        @close="close"></good-info-dialog>
      <!-- 一次性活动弹窗 -->
      <exchange-prize-dialog v-if="participationTipsOneTimeDialogVisible" width="90%" class="activity-tip-dialog">
        <div class="activity-tip-context">
          你已符合{{ activityDialogTitle }}参与条件，是否立即领奖？
        </div>
        <img style="width: 80%; height: auto" src="../../assets/gongzai.jpg" alt="活动图片">
        <div class="activity-tip-button">
          <button class="activity-tip-cancel" @click="handleCancelParticipationTip">取消</button>
          <button class="activity-tip-ok" @click="handleParticipationTip">立即报名</button>
        </div>
      </exchange-prize-dialog>
      <!-- <exchange-prize-dialog v-if="fanDialogVisible" width="90%" class="activity-tip-dialog">
        <div class="activity-tip-context">
          8月18日~10月11日期间，中秋保温礼袋团购活动进行中，5袋起订（每袋30支），送礼更贴心。详情可点击小程序广告区的图片，可以跳转到专属订购页面。
        </div>

        <img style="width: 80%; height: auto" src="../../assets/dai.png" alt="活动图片">
        <div class="activity-tip-button">
          <button class="activity-tip-ok" @click="handleCancelFanTip">确认</button>
        </div>
      </exchange-prize-dialog> -->

      <!-- <exchange-prize-dialog v-if="kittyDialogVisible" width="90%" class="activity-tip-dialog">
        <div class="activity-tip-context">
          10月09日起,宅配渠道购买指定4排益力多产品套装(原味/水蜜桃/青提味/500亿)(原价108元，现活动优惠价86.5元)，即可获得联名玻璃水杯被1份!数量有限，售完即止
        </div>
        <img style="width: 50%; height: auto" src="https://admin-api.yakult-gz.com.cn/upload/images/xiaoyedeng.jpg"
             alt="活动图片">
        <div class="activity-tip-button">
          <button class="activity-tip-ok" @click="handleCancelKittyTip">确认</button>
        </div>
      </exchange-prize-dialog> -->

      <!--公告-->
      <rule-info-dialog v-if="isNotice" :description="notice" @close="closeRule"></rule-info-dialog>
      <!-- 首页原味大图弹窗 -->
      <notice-img-dialog v-if="isImgNotice" @close="isImgNotice = false" />
      <!-- 首页水蜜桃抽奖大图弹窗 -->
<!--      <notice-img-dialog v-if="isPeachLotteryImgNotice" :img-url="peachLotteryImgUrl" @close="isPeachLotteryImgNotice = false;isImgNotice = true" />-->
      <!-- 首页kitty大图弹窗 -->
<!--      <notice-img-dialog v-if="isKittyImgNotice" :img-url="kittyImgUrl" @close="isKittyImgNotice = false" />-->

      <!-- <base-dialog v-if="generalDialogIsVisible" width="80%" @close="closeGeneralDialog()">
        <p style="font-size: 18px; text-align: left; color: #666666">{{ generalDialogContent }}</p>
        <img v-for="(generalDialogImgUrl, index) in generalDialogImgUrls" :key="index" class="general-image"
             :src="generalDialogImgUrl" alt="活动图片">
      </base-dialog> -->
      <exchange-prize-dialog v-if="activityTipDialogVisible" width="90%" class="activity-tip-dialog">
        <div class="activity-tip-context">{{ activityDialogContent }}</div>
        <img style="width: 80%; height: auto" src="../../assets/gongzai.jpg" alt="活动图片">
        <div class="activity-tip-button">
          <button class="activity-tip-cancel" @click="handleCancelActivityTip">取消</button>
          <button class="activity-tip-ok" @click="handleViewActivityTip">查看</button>
        </div>
      </exchange-prize-dialog>
      <!-- 分批次活动弹窗 -->
      <!-- <exchange-prize-dialog v-if="participationTipsDialogVisible" width="90%" class="activity-tip-dialog">
        <div class="activity-tip-context">你已符合{{ activityDialogTitle }}参与条件，是否立即领奖？</div>
        <img style="width: 80%; height: auto" src="../../assets/gongzai.jpg" alt="活动图片">
        <div class="activity-tip-button">
          <button class="activity-tip-cancel" @click="handleCancelParticipationTip">取消</button>
          <button class="activity-tip-ok" @click="handleParticipationTip">立即报名</button>
        </div>
      </exchange-prize-dialog> -->

      <!--平台协议-->
      <base-dialog v-if="ruleVisible" :title="title" width="80%" @close="close(1)">
        <div class="rule">
          <p>▶支持城市</p>
          <p>深圳市、佛山市、广州市、东莞市、惠州市、中山市、湛江市、汕头市、清远市、肇庆市</p>
          <!--{{&#45;&#45;<p > 深圳市新洲配送中心配送区域 < /p>&#45;&#45;}}-->
          <h5>请阅读以下协议</h5>
          <p> 1.本系统会获取您当前位置信息，电话号码，配送地址等用户数据，来为您提供配送服务。<br/>
            2.本系统的用户数据遵循网站会员服务条款。（拷贝本链接后再浏览器上打开：http://mobile.yakult-gz.com.cn/index.php/Wx/wxh_registered）<br/>
            3.服务条款的修改和责任限制<br/>
            ▶本网站有权在必要时无须对用户进行公告而修改服务条款。如果不同意所改动的内容，用户可以主动停止使用所获得的网络服务。如果用户继续享用网络服务，
            则被视为接受服务条款的变动。<br/>
            ▶本网站保留随时修改、暂停或中断服务而不需告知用户的权利。<br/>
            ▶本网站行使修改、暂停或中断服务的权利时，不需对用户或第三方负责。<br/>
            ▶本网站不保证向用户提供的服务是连续的、准确的或及时的，不保证缺陷一定会被纠正，也不保证所提供的服务或服务器不受病毒或其他有害成分的侵袭。<br/>
            ▶在未征得您事先同意的条件下，不会向第三方提供或透漏您的个人信息。<br/>
            4.服务的终止 <br/>
            ▶本网站承诺将尽最大努力维持本网站的网络服务的正常运行，同时保留根据实际情况中断一项或多项网络服务的权利。<br/>
            ▶本网站不需对任何个人或第三方负责而随时中断服务。用户对后来的条款修改有异议，或对本网站的服务不满，可以行使如下权利：(1)停止使用本网站的网络服务。(2)通告本网站停止对该用户的服务。<br/>
            5.通告<br/>
            ▶所有发给用户的通告都可通过网站页面发布。服务条款的修改、服务变更、或其它重要事件的通告都会以此形式进行。<br/>
            6.法律 <br/>
            ▶本服务条款与中华人民共和国的法律解释相一致，用户和本网站一致同意接受中华人民共和国法律的管辖。如发生本网站服务条款与中华人民共和国法律相抵触时，则这些条款将完全按法律规定重新解释。而其它条款则依旧保持对用户产生法律效力和影响。<br/>
            7.本服务条款的最终解释权归属广州益力多乳品有限公司。<br/>
          </p>
        </div>
      </base-dialog>

      <!-- <base-dialog v-if="newProduct"  width="80%" @click="close()" style="font-size: 1.2rem;">
         益力多芒果味4月11日隆重上市，4月3日-10日期间，在小程序提前订购【益力多芒果味】2排或以上可获得双倍印花！(预售期间不可与其他商品同时下单)
         <img style="width: 50%; height: auto" src="https://order-api.yakult-gz.com.cn/upload/images/mango.jpg"
             alt="活动图片">
      </base-dialog> -->

      <base-dialog v-if="doubleStampPromotionActive" width="80%" @close="closePromotion()">
        <p style="font-size: 18px; text-align: left; color: #666666">6月5号低糖10支家庭装隆重上市，6月1号-6月4号预售，下单享双倍印花，6月5号开始配送</p>
        <img style="width: 100%; height: auto" src="https://order-api.yakult-gz.com.cn/upload/images/ten_dt.jpg"
             alt="活动图片">
      </base-dialog>

<!--      <base-dialog v-if="generalDialogIsVisible" width="80%" @close="closeGeneralDialog()">-->
<!--        <p style="font-size: 18px; text-align: left; color: #666666">益力多芒果味4月11日隆重上市，4月3日-10日期间，在小程序提前订购【益力多芒果味】2排或以上可获得双倍印花！(预售期间不可与其他商品同时下单)</p>-->
<!--        <img class="general-image"-->
<!--             src="https://order-api.yakult-gz.com.cn/upload/images/mango.jpg" alt="活动图片">-->
<!--      </base-dialog>-->

      <!--执照-->
      <div class="dialog-wrapper" v-if="componterVisible" @click="close()">
        <img v-if="blisVisible" class="blis-img" alt=""
             src="http://mobile.yakult-gz.com.cn/%E8%90%A5%E4%B8%9A%E6%89%A7%E7%85%A7.jpg"/>
        <img v-if="nmpaVisible" class="nmpa-img" alt=""
             src="http://mobile.yakult-gz.com.cn/%E9%A3%9F%E5%93%81%E7%BB%8F%E8%90%A5%E8%AE%B8%E5%8F%AF%E8%AF%81.jpg"/>
        <img v-if="jyVisible" class="nmpa-img" alt=""
             src="http://mobile.yakult-gz.com.cn/%E9%A3%9F%E5%93%81%E7%BB%8F%E8%90%A5%E8%AE%B8%E5%8F%AF%E8%AF%81.jpg"/>
        <img v-if="qsVisible" class="nmpa-img" alt=""
             src="http://mobile.yakult-gz.com.cn/%E9%A3%9F%E5%93%81%E7%94%9F%E4%BA%A7%E8%AE%B8%E5%8F%AF%E8%AF%81.jpg"/>
      </div>

      <!--参与游戏-->
      <game-dialog v-if="gameVisible" @inter="inter()" @close="close()" @tip="tipBox"></game-dialog>

      <!--兑换奖励-->
      <exchange-prize-dialog v-if="prizeVisible" width="80%">
        <p class="prize-title">恭喜您获得奖励！</p>
        <p>请选择益力多/低糖，选择您的收货地址，益力多姐姐会联系您进行配送。</p>
        <div class="radio-box" v-for="(item,index) in radios" :key="item.id">
          <span class="radio" :class="{'on':item.isChecked}"></span>
          <input v-model="prizeGood" :value="item.value" class="input-radio" :checked='item.isChecked'
                 @click="check(index)" type="radio">{{ item.label }}
        </div>
        <div class="address">
          <div v-if="addAddress" class="place-header-detail">
            <span class="add-address" @click="modifyAddress">添加收货地址</span>
          </div>
          <div v-else class="place-header-detail" @click="modifyAddress">
            <div class="detail-info">
              <div class="username">
                <span>{{ username }}</span> <span style="margin-left: 40px">{{ tel }}</span>
              </div>

              <div class="address">
                {{ address }}
              </div>
            </div>

            <img class="icon" src="../../assets/common_next.png" alt=""
                 style="background: #faf2ed">

            <div style="clear:both;"></div>
          </div>
        </div>
        <button class="prize-tip-ok" @click="submitOrder" :disabled="btnDisable">确认</button>
      </exchange-prize-dialog>
    </div>

    <div class="toast" v-show="toastShow">
      {{ toastText }}
    </div>
  </header-bar>
</template>

<script>
import HeaderBar from "../../components/HeaderBar";
import {GoodsList, GoodsListByCity} from "@/api/Goods";
import {BASE_URL, GAME_URL, LIMIT} from "@/config/app";
import GoodInfoDialog from "@/components/GoodInfoDialog";
import RuleInfoDialog from "@/components/RuleInfoDialog";
import {ClientNotice} from "@/api/ClientNotice";
import {memberGameStatus, ruleRead, updateMemberGameStatus} from "@/api/Member";
import {RECEIVE_RULE_READ} from "@/store/mutation-types";
import GameDialog from "@/components/GameDialog";
import {AddressDefault} from "@/api/Address";
import {starPhone} from "@/unitls";
import BaseDialog from "@/components/BaseDialog";
import ExchangePrizeDialog from "@/components/ExchangePrizeDialog";
import {OrderSubmit} from "@/api/Orders";
import {PackageListByCity} from "@/api/Package"
import {CheckActivityDate} from "../../api/Activity";
import {GetPackageOrderDeliver} from "@/api/PackageOrder";
import {getHomeDialogContent} from "../../api/SysOpt";
import {GOODS} from "../../constant/goods";
import {GetPackageSellOutArea} from "../../api/PackageOrder";
import NoticeImgDialog from "@/components/NoticeImgDialog.vue";

export default {
  name: "Home",
  computed: {
    GOODS() {
      return GOODS
    }
  },
  components: {NoticeImgDialog, ExchangePrizeDialog, GameDialog, BaseDialog, GoodInfoDialog, HeaderBar, RuleInfoDialog},

  data() {
    return {
      produceData: [],
      preProduceData: [],
      packageData: [],
      showPackageRule: false,
      showToBuy: false,


      notice: '',
      goodsId: [],
      isShowGoodInfo: false,
      title: '',
      weight: '',
      description: '',

      isNotice: false,
      isImgNotice: true,
      isPeachLotteryImgNotice: true,
      peachLotteryImgUrl: 'https://order-api.yakult-gz.com.cn/upload/images/peach-lottery-notice.jpg',
      isKittyImgNotice: true,
      kittyImgUrl: 'https://order-api.yakult-gz.com.cn/upload/images/kitty_20260625.jpg',
      showPop: '',

      yaklut: true,
      yaklutDt: true,
      yaklutSugarFree: true,

      ruleVisible: false,

      componterVisible: false,
      blisVisible: false,
      nmpaVisible: false,
      jyVisible: false,
      qsVisible: false,

      tipTotal: false,
      prizeVisible: false,
      gameVisible: false,
      addAddress: false,
      prizeGood: '0',
      radios: [
        {
          label: GOODS.YAKULT,
          value: '0',
          isChecked: true,
        },
        {
          label: GOODS.YAKULT_DT_ABBREVIATION,
          value: '1',
          isChecked: false,
        },
      ],

      username: '',
      tel: '',
      address: '',
      addressId: 0,

      toastShow: false,
      toastText: '',

      btnDisable: false,

      activityTipDialogVisible: false,
      participationTipsDialogVisible: false,
      participationTipsOneTimeDialogVisible: false,
      activityDialogContent: '',
      activityDialogTitle: '',
      isPackage: true,
      cityShowCheck: true,
      generalDialogIsVisible: false,
      doubleStampPromotionActive: false,
      generalDialogContent: '',
      generalDialogImgUrls: [],
      packageSellOutArea: '',
      packageSellOutAreaCount: 0,
      fanDialogVisible: true,
      kittyDialogVisible: true,
      cumulativeFlag: false,
      availableCount: 0
    }
  },

  created() {
    let read = localStorage.getItem(RECEIVE_RULE_READ);
    if (read === 'false') {
      this.ruleVisible = true;
    } else {
      this.ruleVisible = false;
    }
  },

  mounted() {
    let currentDate = this.getDate();
    if (localStorage.getItem('lastLogin') === '' || localStorage.getItem('lastLogin') !== currentDate) {
      localStorage.setItem('showPop', 'true');
      localStorage.setItem('lastLogin', currentDate);
    } else {
      localStorage.setItem('showPop', 'false');
    }


    localStorage.setItem("yakultNum", "");
    localStorage.setItem("yakultDtNum", "");
    localStorage.setItem("yakultNoSugarNum", "");
    localStorage.setItem("remark", "");
    this.showPop = localStorage.getItem('showPop');

    // let addId = localStorage.getItem('addressId');
    // if (addId == null || addId === '') {
    //     //获取用户默认收货地址
    //     this.requestMemberDefaultAddress();
    // } else {
    //     this.addressId = localStorage.getItem('addressId');
    //     this.username = localStorage.getItem('username');
    //     this.address = localStorage.getItem('userAddress');
    //     this.tel = localStorage.getItem('userPhone');
    // }
    if (localStorage.getItem('showPop') === 'true') {
      this.requestClientNotice();
    }

    let addId = localStorage.getItem('addressId');
    if (addId == null || addId === '') {
      //获取用户默认收货地址
      this.requestMemberDefaultAddress().then(() => {
        this.requestGoodsListByCity(0);
      })
    } else {
      this.addressId = localStorage.getItem('addressId');
      this.username = localStorage.getItem('username');
      this.address = localStorage.getItem('userAddress');
      this.tel = localStorage.getItem('userPhone');
      this.requestGoodsListByCity(0);
    }

    this.requestGeneralDialogStatusAndContent();
    this.getPackageSellOutArea();
    // this.requestGoodsList();
    // this.checkDoubleStampPromotion();
    // this.requestGameStatus();
    this.requestCheckActivityDate();
  },


  methods: {
    close(value) {
      this.isShowGoodInfo = false;
      this.ruleVisible = false;
      this.componterVisible = false;
      // this.prizeVisible = false;
      this.gameVisible = false;
      this.$emit('close');

      if (value === 1) {
        this.requestRule();
        // this.checkDoubleStampPromotion();
      }

      if (this.tipTotal) {
        updateMemberGameStatus()
            .then((response) => {
              if (response.code === this.$API_CODE.OK) {
                //更新会员本月已参与游戏
                this.tipTotal = false;
              }
            });
      }
    },

    closeGeneralDialog() {
      this.generalDialogIsVisible = false
      this.generalDialogContent = ''
    },

    closePromotion() {
      this.doubleStampPromotionActive = false
    },

    requestGeneralDialogStatusAndContent() {
      console.log("requestGeneralDialogStatusAndContent");
      console.log(this.generalDialogIsVisible + "111");
      getHomeDialogContent().then((response) => {
        if (response.code === this.$API_CODE.OK) {
          this.generalDialogIsVisible = response.data.isVisible;
          this.doubleStampPromotionActive = response.data.isPresale;
          if (this.generalDialogIsVisible) {
            this.generalDialogContent = response.data.content;
            this.generalDialogImgUrls = response.data.imgUrls;
          }
        }
      })
    },
    // checkDoubleStampPromotion() {
    //   let currentDate = new Date();
    //   let currentYear = currentDate.getFullYear();
    //   let currentMonth = currentDate.getMonth() + 1;
    //   let currentDay = currentDate.getDate();
    //   const isDoubleStampPromotion = !(currentYear !== 2025 || currentMonth !== 4 || (currentDay !== 14 && currentDay !== 15));
    //   if (isDoubleStampPromotion) {
    //     this.doubleStampPromotionActive = true
    //   } else {
    //     this.doubleStampPromotionActive = false
    //   }
    // },
    closeRule() {
      this.isNotice = false;
      // this.checkDoubleStampPromotion();
    },
    getDate() {
      const date = new Date();
      const year = date.getFullYear();
      let month = date.getMonth() + 1;
      let day = date.getDate();
      if (month < 10) {
        month = "0" + month;
      }
      if (day < 10) {
        day = "0" + day;
      }
      let nowDate = year + "-" + month + "-" + day;
      return nowDate;
    },
    toast(e) {
      let _that = this;
      this.toastText = e;
      this.toastShow = true;
      setTimeout(function () {
        _that.toastShow = false;
      }, 1500)
    },

    inter() {
      //跳转游戏活动
      window.location.href = GAME_URL;
      // updateMemberGameStatus()
      //     .then((response) => {
      //        if (response.code === this.$API_CODE.OK) {
      //            //更新会员本月已参与游戏
      //            this.tipTotal = false;
      //        }
      //     });
    },
    //当月不再提示游戏邀请
    tipBox(value) {
      this.tipTotal = value;
    },
    //设置兑奖商品
    check(index) {
      // 先取消所有选中项
      this.radios.forEach((item) => {
        item.isChecked = false;
      });
      //再设置当前点击项选中
      this.sex = this.radios[index].value;
      // 设置值，以供传递
      this.radios[index].isChecked = true;
    },

    modifyAddress() {
      let addId = localStorage.getItem('addressId');
      if (addId !== null && addId !== '') {
        localStorage.setItem('addressId', this.addressId);
      }
      this.$router.push({path: '/addressChoose', query: {}})
    },

    //兑换下单赠饮订单
    submitOrder() {
      if (this.addressId == "") {
        this.toast("收货地址不存在")
        return
      }
      let goodsId = [];
      let numbers = [];
      let unitprices = [];
      let remark = "游戏活动中奖赠饮订单";
      for (let i = 0; i < this.produceData.length; i++) {
        goodsId[i] = this.produceData[i].id;
        unitprices[i] = 0;

        numbers[i] = 0;
        if ((this.prizeGood == 0 && this.produceData[i].name === GOODS.YAKULT)) {
          numbers[i] = 1;
        }
        if ((this.prizeGood == 1 && this.produceData[i].name === GOODS.YAKULT_DT)) {
          numbers[i] = 1;
        }
      }
      this.btnDisable = true;
      OrderSubmit(goodsId.join(','), numbers.join(','), unitprices.join(','), remark, this.addressId, true, 0)
          .then((response) => {
            if (response.code === this.$API_CODE.OK) {
              // this.messageVisible = false;
              let orderId = response.data.orderId;
              let orderNumber = response.data.orderNumber;
              let orderData = response.data.forecastDeliverTime;
              let freed = true;
              this.$router.push({path: '/orderSuccess', query: {orderId, orderNumber, orderData, freed}});
              this.prizeVisible = false;
            } else {
              this.toast(response.message)
            }
            this.btnDisable = false;
          });
    },

    //营业执照弹框
    dialogBLIS(value) {
      this.componterVisible = true;
      if (value === 1) {
        this.blisVisible = true;
        this.nmpaVisible = false;
        this.jyVisible = false;
        this.qsVisible = false;
      } else if (value === 2) {
        this.blisVisible = false;
        this.nmpaVisible = true;
        this.jyVisible = false;
        this.qsVisible = false;
      } else if (value === 3) {
        this.blisVisible = false;
        this.nmpaVisible = false;
        this.jyVisible = true;
        this.qsVisible = false;
      } else {
        this.blisVisible = false;
        this.nmpaVisible = false;
        this.jyVisible = false;
        this.qsVisible = true;
      }
    },
    requestClientNotice() {
      ClientNotice()
          .then((response) => {
            if (response.code === this.$API_CODE.OK) {
              console.log(this.showPop === 'true');
              if (response.data.content !== '' && this.showPop === 'true') {
                this.isNotice = true;
              }
              this.notice = response.data.content;
            }
          });
    },

    requestGameStatus() {
      memberGameStatus()
          .then((response) => {
            if (response.code === this.$API_CODE.OK) {
              var type = response.data.gameStatusType;
              if (type === this.$MEMBER_GAME.NOT_JOIN_GAME) {
                //不可参与游戏
                this.gameVisible = false;
                this.prizeVisible = false;
              } else if (type === this.$MEMBER_GAME.JOIN_GAME) {
                //可参与游戏
                this.gameVisible = true;
                this.prizeVisible = false;
              } else if (type === this.$MEMBER_GAME.PRIZED) {
                //兑换奖励
                this.gameVisible = false;
                this.prizeVisible = true;

              }
            }
          })

    },

    requestRule() {
      ruleRead()
          .then((response) => {
            if (response.code === this.$API_CODE.OK) {
              this.ruleVisible = false;
              localStorage.setItem(RECEIVE_RULE_READ, 'true');
            }
          });
    },

    requestGoodsList() {
      GoodsList(-1, LIMIT)
          .then((response) => {
            if (response.code === this.$API_CODE.OK) {
              this.produceData = [];
              let length = response.data.list.length
              response.data.list.forEach((item, index) => {
                this.produceData.push({
                  id: item.id,
                  name: item.name,
                  description: item.description,
                  price: this.numFilter(item.price),
                  spec: item.spec,
                  isNew: item.isNew,
                  imageUrl: BASE_URL + item.imageUrl,
                  // 判断是否显示商品下方的红色下划线
                  lineShow: index == length - 1 ? false : true
                })
              });

              this.produceData.forEach((item, index) => {
                switch (index) {
                  case 0:
                    this.produceData[index].name = GOODS.YAKULT + "(" + GOODS.YAKULT_SUGAR_FREE_ABBREVIATION + ")"
                    break;
                  case 1:
                    this.produceData[index].name = GOODS.YAKULT + "(" + GOODS.YAKULT_PEACH_ABBREVIATION + ")"
                    break;
                  case 2:
                    this.produceData[index].name = GOODS.YAKULT + "(" + GOODS.YAKULT_ABBREVIATION + ")"
                    break;
                  case 3:
                    this.produceData[index].name = GOODS.YAKULT + "(" + GOODS.YAKULT_DT_ABBREVIATION + ")"
                    break;
                  default:
                    break
                }
              })

              this.goodsId = [];
              let total = response.data.total;
              if (total > 0) {
                this.yaklut = true;
                if (total > 1) {
                  this.yaklutDt = true;
                  if (total > 2) {
                    this.yaklutSugarFree = true;
                  } else {
                    this.yaklutSugarFree = false;
                  }
                } else {
                  this.yaklutDt = false;
                }
              } else {
                this.yaklutDt = false;
                this.yaklut = false;
              }

              response.data.list.forEach((item) => {
                this.goodsId.push({
                  id: item.id,
                })
              });

            }
          });
    },

    requestGoodsListByCity() {
      GoodsListByCity(-1, LIMIT, this.addressId, 0).then((response) => {
        if (response.code === this.$API_CODE.OK) {
          let length = response.data.list.length
          response.data.list.forEach((item, index) => {
            this.produceData.push({
              id: item.id,
              name: item.name,
              description: item.description,
              price: item.price,
              spec: item.spec,
              isNew: item.isNew,
              imageUrl: BASE_URL + item.imageUrl,
              // 判断是否显示商品下方的红色下划线
              lineShow: index !== length - 1
            })
          });
        }
      });
      GoodsListByCity(-1, LIMIT, this.addressId, 1).then((response) => {
        if (response.code === this.$API_CODE.OK) {
          let length = response.data.list.length
          response.data.list.forEach((item, index) => {
            this.preProduceData.push({
              id: item.id,
              name: item.name,
              description: item.description,
              price: item.price,
              spec: item.spec,
              isNew: item.isNew,
              imageUrl: BASE_URL + item.imageUrl,
              // 判断是否显示商品下方的红色下划线
              lineShow: index !== length - 1
            })
          });
        }
      });

      PackageListByCity({page: -1, limit: LIMIT, areaId: this.addressId}).then(res => {
        if (res.code === this.$API_CODE.OK) {
          let list = []
          let length = res.data.packages.length;
          if (res.data.packages) {
            res.data.packages.forEach((item, index) => {
              list.push({
                packageId: item.packageId,
                imageUrl: BASE_URL + item.imageUrl,
                name: item.packageName,
                price: item.priceSum,
                spec: item.spec,
                gift: item.gift,
                firstGift: item.firstGift,
                packageType: item.packageType,
                addPurchaseGoods: item.addPurchaseGoods,
                preferentialPrice: item.preferentialPrice,
                description: item.description,
                lineShow: index !== length - 1
              })
            })
          }
          this.packageData = list
        }
      })
    },


    placeOrder(type) {
      this.$router.push({path: '/placeOrder', query: {type}})
    },

    placePackageOrder(id) {
      console.log(id)
      this.$router.push({path: '/packagePlaceOrder', query: {id}})
    },

    // 截取当前数据到小数点后两位
    numFilter(value) {
      const realVal = parseFloat(value).toFixed(2);
      return realVal;
    },

    showGoodInfo(goodInfo) {
      this.isShowGoodInfo = true;
      this.title = goodInfo.name;
      this.weight = goodInfo.spec;
      this.description = goodInfo.description;

    },

    requestMemberDefaultAddress() {
      return AddressDefault()
          .then((response) => {
            if (response.code === this.$API_CODE.OK) {
              if (response.data) {
                this.addressId = response.data.id;
                this.username = response.data.consignee;
                this.tel = starPhone(response.data.mobile);
                this.address = response.data.area + response.data.address;
                localStorage.setItem('addressId', this.addressId);
                localStorage.setItem('username', this.username);
                localStorage.setItem('userAddress', this.address);
                localStorage.setItem('userPhone', this.tel);
              } else {
                this.addAddress = true;
              }

            }
          })
    },
    handleCancelActivityTip() {
      this.activityTipDialogVisible = false;
    },

    handleViewActivityTip() {
      this.$router.push({path: '/activity'});
    },

    requestCheckActivityDate() {
      CheckActivityDate().then((response) => {
        if (response.code === this.$API_CODE.OK) {
          this.activityTipDialogVisible = response.data.isWithinActivityPeriod && !response.data.canParticipate && !response.data.alreadyParticipated;
          this.participationTipsDialogVisible = response.data.isWithinActivityPeriod && response.data.canParticipate && !response.data.alreadyParticipated && response.data.cumulativeFlag;
          this.participationTipsOneTimeDialogVisible = response.data.isWithinActivityPeriod && response.data.canParticipate && response.data.available && !response.data.cumulativeFlag;
          this.availableCount = response.data.availableCount;
          this.activityDialogContent = response.data.activityDialogContent;
          this.activityDialogTitle = response.data.activityDialogTitle;
        }
      })
    },

    handleCancelParticipationTip() {
      this.participationTipsDialogVisible = false;
      this.participationTipsOneTimeDialogVisible = false;
    },

    handleParticipationTip() {
      this.$router.push("/mine")
    },

    // 点击套餐 或者 商品
    selectOrder(isPackage) {
      this.isPackage = isPackage;
    },
    // 按城市显示复选框值改变触发
    handleCheckChange() {
      let checked = this.cityShowCheck
      // 不同的状态调用不同的方法
      if (checked) {
        this.requestGoodsListByCity(1)
      } else {
        this.requestGoodsList()
      }
    },
    getNotDeliveredOrderList() {
      // ListPackageOrder({
      //   orderStatus: 0, page: 0, limit: -1
      // }).then((res)=>{
      //   let number= res.data.packageOrderDtos[0].remainDeliverPeriod
      //   console.log("========================="+res.data)
      //   if(res.code===this.$API_CODE.OK){
      //     this.showPackageRule=true
      //     this.remainingPeriods=number
      //   }
      // })
      GetPackageOrderDeliver().then(res => {
        if (res.code === this.$API_CODE.OK) {
          if (res.data.isExistPackageOrder) {
            this.showPackageRule = true
          }
          if (!res.data.isExistPackageOrder && this.packageData.length > 0) {
            this.showToBuy = true
          }
        }
      })
    },

    getPackageSellOutArea() {
      GetPackageSellOutArea().then(res => {
        if (res.code === this.$API_CODE.OK) {
          this.packageSellOutArea = res.data.packageSellOutArea;
          this.packageSellOutAreaCount = res.data.packageSellOutAreaCount;
        }
      })
    },

    handleCancelFanTip() {
      this.fanDialogVisible = false;
    },

    handleCancelKittyTip() {
      this.kittyDialogVisible = false;
    }
  }
}
</script>

<style scoped lang="scss">

#home {
  width: 100%;
  height: 100%;
  background: #FFFFFF;

  .tab-container {
    position: relative;
    margin: 16px 16px 0;
    box-shadow: 0 4px 12px rgba(0,0,0,0.15);
    border-radius: 12px;
    padding: 16px;
    transform: translateY(0);
    transition: all 0.3s ease;
  }

  .tab-container:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(0,0,0,0.2);
  }



    .tab-wrapper {
      display: flex;
      position: relative;
      z-index: 1;
      gap: 16px;
    }

    .tab {
      flex: 1;
      height: 56px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      transition: all 0.3s ease;
      position: relative;
      border-radius: 12px;
    }
    .tab:active {
      transform: scale(0.98);
    }

    .tab-text {
      font-size: 1rem;
      font-weight: 600;
      color: inherit;
    }



    .tab-content {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .tab-active .tab-text {
      color: #333333;
    }

    .tab-inactive .tab-text {
      color: #FFFFFF;
    }

    .tab-active {
      color: #333333;
      background: linear-gradient(to bottom, #ffdfe0, #ffffff);
      box-shadow: 0 -3px 0 #e60139 inset;
      font-weight: 600;
    }

    .tab-inactive {
      color: #FFFFFF;
      background: linear-gradient(to bottom, #f36363 0%, #e60139 100%);
      transition: all 0.3s ease;
      box-shadow: 0 3px 3px rgba(230, 1, 57, 0.3);
    }

    .tab-inactive:hover {
      color: #FFFFFF;
      border-color: #c41e3a;
      background: linear-gradient(135deg, #f36363 0%, #e60139 100%);
      box-shadow: 0 4px 8px rgba(230, 1, 57, 0.3);
    }

    .tab-indicator {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 50%;
      height: 4px;
      background-color: #ea2d53;
      transition: transform 0.3s ease;
      z-index: 2;
      box-shadow: 0 2px 4px rgba(234, 45, 83, 0.3);
    }

    .add-purchase-goods {
      display: inline-block;
      background: #f36363;
      color: #FFFFFFFF;
      height: 23px;
      line-height: 23px;
      align-items: center;
      padding: 1px 6px;
      border-radius: 3px;
      font-size: 0.9rem;
    }

    .new-tag {
      position: absolute;
      top: -8px;
      right: -8px;
      background-color: #FFFFFF;
      color: #e60139;
      font-weight: bold;
      padding: 4px 8px;
      border-radius: 8px;
      border: 2px solid #e60139;
      z-index: 10;
      font-size: 0.8rem;
      margin-left: 4px;

    }
  

  #home-banner {
    position: relative;

    .home-banner-icon {
      width: 100%;
      height: 100%;
    }

    .description {
      border-radius: 5px;
      text-align: left;
      border: 2px solid #ea2d53;
      margin-left: 30px;
      margin-right: 30px;
      margin-top: -50px;
      font-size: 0.9rem;
      color: #ea2d53;
      background: #faf2ed;
      padding: 15px;
      white-space: pre-wrap;
    }

  }

  #home-body {
    //height: 400px;
    /*margin-top: 60px;*/
    /*background: url("../../assets/banner_bg.png") no-repeat center 0;*/
    // background-size: 70% 110%;

    .good-list {
      padding: 16px;
      display: flex;
      flex-direction: column;
      gap: 16px;
      .tip-notice {
        display: flex;
        text-align: left;
        align-items: center;
        background: linear-gradient(135deg, #fffdf5 0%, #fff8e1 100%);
        border: 1px solid #e6a23c;
        border-radius: 12px;
        padding: 20px 24px;
        margin-bottom: 8px;
        box-shadow: 0 2px 8px rgba(230, 162, 60, 0.15);
          .tip-notice-icon {
            font-size: 20px;
            margin-right: 16px;
            flex-shrink: 0;
          }

           .tip-notice-content {
            flex: 1;
            font-size: 15px;
            color: #b88230;
            font-weight: 500;
            line-height: 1.5;
          }

      }

    }

    .home-body-yakult {
       background-color: #ffffff;
        border-radius: 12px;
        box-shadow: 0 4px 12px rgba(0,0,0,0.15);
        overflow: hidden;
        transition: all 0.3s ease;
        transform: translateY(0);
        padding: 10px;

      .home-body-bg-yakult {
        width: 6rem;
        height: 6rem;
        float: left;
        margin-top: 2rem;
        margin-right: 1.3rem;
      }

      .description {
        position: relative;
        text-align: left;
        margin-top: -2%;
        padding-left: 87px;
        margin-left: 30px;
        padding-top: 20px;
        font-size: 0.9rem;
        white-space: pre-wrap;

        .new-product-tag {
          position: absolute;
          top: 20px;
          right: 20px;
          background-color: red;
          color: white;
          padding: 5px 10px;
          font-size: 12px;
          border-radius: 5px;
          z-index: 1;
        }

        .presale-tag {
          position: absolute;
          top: 50px;
          right: 20px;
          background: linear-gradient(135deg, #ffd700 0%, #ffb347 100%);
          color: #8b4513;
          padding: 5px 10px;
          font-size: 12px;
          border-radius: 5px;
          z-index: 1;
          font-weight: 600;
        }

        .description-title {
          color: rgb(236, 49, 29);
          font-weight: bold;
          font-size: 1.2rem;
          padding-top: 1vh;
        }

        .description-title-low {
          color: rgb(94, 139, 210);
          font-weight: bold;
          font-size: 1.2rem;
          padding-top: 1vh;
        }

        .description-title-500low {
          color: rgb(216, 182, 109);
          font-weight: bold;
          font-size: 1.2rem;
          padding-top: 1vh;
        }

        .description-title-peach {
          color: #DD1673;
          font-weight: bold;
          font-size: 1.2rem;
          padding-top: 1vh;
        }

        .description-title-grape {
          color: #00b050;
          font-weight: bold;
          font-size: 1.2rem;
          padding-top: 1vh;
        }

        .description-title-mango {
          color: #b3b311;
          font-weight: bold;
          font-size: 1.2rem;
          padding-top: 1vh;
        }

        .description-content {
          margin-top: 8px;
          color: #6b6b68;
          font-weight: bold;
          font-size: 0.8rem;
          word-wrap: break-word;
          line-height: 1.4;
        }
        .con-down { 
          margin-top: 16px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          position: relative;
          flex-wrap: wrap;
         }

         .price-num {
          font-size: 1.2rem;
          font-weight: 700;
          color: #333;
          flex: 1;
          min-width: 0;
         }

         .price-btn {
          border: 1px solid #ea2d53;
          border-radius: 20px;
          padding: 8px 20px;
          background-color: #ea2d53;
          color: white;
          font-weight: 600;
          width: 120px;
          text-align: center;
          font-size: 0.9rem;
          transition: all 0.3s ease;
          box-shadow: 0 2px 4px rgba(234, 45, 83, 0.3);
          flex-shrink: 0;
          margin-left: 16px;
         }

         .price-btn:active {
            transform: scale(0.95);
            box-shadow: 0 1px 2px rgba(234, 45, 83, 0.3);
          }

        .material {
          margin-top: 10px;
          margin-right: 20px;
          height: 65px;
          overflow: hidden;
          color: #757575;
        }


        .price-box {
          margin-top: 10px;
          margin-left: 20px;
          position: relative;

          .price-box-price {
            float: right;
            margin-top: -3.0em;
            margin-right: 1.3em;
            font-size: 1.2rem;
            font-weight: bold;
          }

          .price-box-btn {
            float: right;
            border: 1px solid #e35f85;
            border-radius: 15px;
            padding: 3px 8px;
            background-color: #e35f85;
            color: white;
            font-weight: bold;
            margin-top: -2.5em;
            margin-right: 1.5em;
            width: 5rem;
            text-align: center;
          }

          .price-box-phase {
            float: right;
            padding: 3px 15px;
            border: 2px solid #ea2d53;
            margin-right: 1rem;
            margin-top: 5px;
            color: #ea2d53;
          }
        }
      }
    }

    .hr1 {
      height: 1px;
      border: none;
      border-top: 1px solid #f0f0f0;
      margin: 15px;
    }
  }

  .rule {
    height: 350px;
    overflow-y: auto;
    overflow-x: hidden;
    text-align: left;
  }

  .purchase {
    display: flex;
    width: 80%;
    justify-content: center;
    padding: 15px 15px;
    background: #ea2d53;
    /*border: 2px solid #ea2d53;*/
    margin: auto;
    margin-top: 5vh;
    border-radius: 8px;
    color: #ea2d53;
  }

  .computer {
    margin-top: 10%;
    font-size: 0.7rem;
    font-weight: bold;
    text-align: center;

    color: #000000;

    .blis {
      color: #4b72a4;
    }
  }

  .computer-footer {
    height: 5rem;
  }

  .dialog-wrapper {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);
    z-index: 100;

    .blis-img {
      width: 96%;
      left: 50%;
      position: absolute;
      margin-left: -48%;
      top: 50%;
      margin-top: -40%;
    }

    .nmpa-img {
      width: 96%;
      left: 50%;
      position: absolute;
      margin-left: -48%;
      top: 50%;
      margin-top: -40%;
    }

  }

  .prize-title {
    font-size: 1.5rem;
    color: #ea2d53;
  }

  .radio-box {
    display: inline-block;
    position: relative;
    height: 25px;
    line-height: 25px;
    margin-right: 10px;
    width: 40%;
    text-align: left;
    margin-left: 10px;
  }

  .input-radio {
    display: inline-block;
    position: absolute;
    opacity: 0;
    width: 80px;
    height: 25px;
    left: 0px;
    outline: none;
    -webkit-appearance: none;
  }

  .radio {
    display: inline-block;
    width: 25px;
    height: 25px;
    vertical-align: middle;
    background-image: url(../../assets/radio_off.png);
    background-repeat: no-repeat;
    //background-position: 0 0;
    background-size: 100% 100%;
    margin-top: -3px;
    margin-right: 15px;
  }

  .on {
    width: 25px;
    height: 25px;
    background-image: url(../../assets/radio_on.png);
    background-size: 100% 100%;
  }

  .address {
    padding: 10px 5px;
    /*height: 8rem;*/
    width: 100%;

    .place-header-detail {
      background: #F2F2F2;
      /*margin-top: 15px;*/
      border-radius: 5px;
      padding: 15px;
      text-align: center;
      border: 2px solid lightgray;

      .add-address {
        background: #ea2d53;
        padding: 8px 15px;
        border-radius: 5px;
        color: #FFFFFF;
        font-weight: bold;
        font-size: 1rem;
        margin-top: -8px;
        /*float: right;*/
      }

      .detail-info {
        //float: left;

        .username {
          text-align: left;
          font-size: 0.8rem;
        }

        .address {
          text-align: left;
          font-size: 0.7rem;
          margin-top: 5px;
          color: #ea2d53;
          float: left;
          width: 80%;
        }
      }

      .icon {
        margin-left: 10px;
        margin-top: 15px;
        float: right;
      }
    }
  }

  .prize-tip-ok {
    position: absolute;
    bottom: 0;
    width: 100%;
    background: #ea2d53;
    height: 40px;
    line-height: 40px;
    color: #FFFFFF;
    font-size: 1rem;
    border-bottom-right-radius: 10px;
    border-bottom-left-radius: 10px;
    left: 0;
    border: 0;
    padding: 0;
  }


  @media screen and (max-width: 320px) {
    #home {
      #home-body {
        /*height: 100%;*/
        /*background: url("../../assets/banner_bg.png") no-repeat center 0;*/
        background-size: 70% 110%;

        .home-body-yakult-low-sugar {
          margin-top: 70px;
          font-size: 0.9rem;
        }

        .icon {
          margin-right: 10px;
        }
      }
    }
  }


  @media screen and (min-width: 321px) and (max-width: 375px) {
    #home-body {
      height: 100%;

      .home-body-yakult-low-sugar {
        margin-top: 70px;
        font-size: 0.9rem;
      }

      .icon {
        margin-right: 15px;
      }
    }
  }


  @media screen and (min-width: 375px) {
    #home-body {
      height: 100%;

      .home-body-yakult-low-sugar {
        margin-top: 110px;
        font-size: 0.9rem;
      }

      .icon {
        margin-right: 1.1rem;
      }
    }
  }

  .activity-tip-dialog {
    ::v-deep .dialog-body {
      padding-top: 15px !important;
      padding-bottom: 15px !important;
    }

    .activity-tip-title {
      color: #ea2d53;
      font-weight: bold;
      text-align: center;
      font-size: 18px;
      margin-top: 10px;
    }

    .activity-tip-context {
      text-align: left;
      margin: 7.5px 7.5px;
      line-height: 1.6;
      word-wrap: break-word;
      word-break: break-all;
      color: #666;
      font-size: 18px;
    }

    .activity-image {
      /* width: 240px;
      height: 160px; */
      width: 240px;
      height: 159px;
    }

    .activity-tip-button {
      display: flex;
      justify-content: space-around;
      gap: 15px;
      height: 50px;
      margin-top: 20px;

      .activity-tip-cancel {
        background: #f5f5f5;
        color: #666;
        font-size: 20px;
      }

      .activity-tip-ok {
        background: #ea2d53;
        color: white;
        font-size: 20px;
      }
    }

    .activity-tip-button button {
      min-height: 30px;
      line-height: 1.4;
      padding: 5px 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      white-space: normal;
      word-break: break-all;
      font-size: 15px;
      width: 50%;
    }
  }

  .general-image {
    width: 70%;
    height: auto;
    padding-bottom: 10px;
  }
}

</style>
